<button matRipple [matRippleRadius]="24" [matRippleCentered]="true" class="dialog-close-button" (click)="onClose()">
  <svg-icon svgClass="icon" name="icon-close"></svg-icon>
</button>
<ng-content></ng-content>
